import { api } from './api';
import { IDraft } from '../../interfaces/IDraft';
import { IObject } from '../../interfaces/IObject';
import { IResponse } from '../../interfaces/IResponse';

export const draftApi = api.injectEndpoints({
  endpoints: (build) => ({
    getDraft: build.query<IDraft, string>({
      query: (id) => `draft/${id}/`,
      providesTags: (_result, _err, id) => {
        return [{ type: 'Draft' as const, id }];
      },
    }),
    getDocument: build.query({
      query: (body: IObject) => ({
        url: 'azure/presigned-url/',
        method: 'POST',
        body,
      }),
    }),
    //Get connected draft by passing the project id
    getConnectedDraft: build.query<IResponse<IDraft[]>, string>({
      query: (params) => `draft/${params}`,
      providesTags: (_result, _err, id) => {
        return [{ type: 'Connected Drafts' as const, id }];
      },
    }),
    getCompareDraft: build.query({
      query: (id) => `compare-docx/${id}/`,
      providesTags: (_result, _err, id) => {
        return [{ type: 'compare-docx' as const, id }];
      },
    }),
    getErrorProne: build.query<{ success: boolean }, void>({
      query: () => 'error-prone',
    }),
  }),
});

export const {
  useGetDraftQuery,
  useGetErrorProneQuery,
  useGetDocumentQuery,
  useGetConnectedDraftQuery,
  useGetCompareDraftQuery,
} = draftApi;

export const {
  endpoints: { getDraft, getDocument, getConnectedDraft, getCompareDraft },
} = draftApi;
